export default function initPrefillCookies($) {
  /* ========================================================================= *\
  **  === Cookies pré-remplissage formulaires                                  *| 
  \* ========================================================================= */

  // recrutement
  $('.accordion--apply').on('click', function() {
    let dataJob = $(this).attr('data-job');
    Cookies.set('job', '');
    Cookies.set('job', dataJob);
  })


  // projet à la vente
  if($('.single-nos-projets-vente').length) {
    $('.button--btn').on('click', function() {
      let dataProjetVente = $('.title-place--title')[0].innerText;
      Cookies.set('projet-vente', '');
      Cookies.set('projet-vente', dataProjetVente);
    })
  }
}
